import { IMessage, MessageType } from "atlas-shared";
import { memo } from "react";

interface IProps {
  message: IMessage;
}

export const ConversationChatMessageMini = memo(({ message }: IProps) => {
  const isSystemMessage = message.type === MessageType.SYSTEM_MESSAGE;

  const messageClassName = isSystemMessage
    ? "conversation-chat-message-mini-item system-message"
    : `conversation-chat-message-mini-item ${message.direction}`;

  return <div className={messageClassName}>{message.text}</div>;
});
